import React from 'react'
import { FormProvider } from 'react-hook-form'
import FullPageOverlay, { IFullPageOverlayProps } from 'transfix-ui/components/FullPageOverlay'
import { Toast } from 'transfix-ui/components/Toast'
import { ISourcedCarrierRateInfoFragment } from '../graphql/SourcedCarrierRateInfoFragment'
import { EditSourcedCarrierRateModalForm } from './EditSourcedCarrierRateModalForm'
import { useSourcedCarrierRateFormSubmitter } from './useSourcedCarrierRateFormSubmitter'

interface IEditSourcedCarrierRateModalProps
  extends Pick<IFullPageOverlayProps, 'open' | 'onClose'> {
  shipperRateId: string
  sourcedCarrierRate?: ISourcedCarrierRateInfoFragment
}

export const EditSourcedCarrierRateModal = ({
  onClose,
  open = false,
  shipperRateId,
  sourcedCarrierRate,
}: IEditSourcedCarrierRateModalProps) => {
  const {
    formMethods,
    handleModalClose,
    isFormValid,
    loading,
    submissionErrors,
    submitHandler,
    toastState: { closeToast, toastMessage, toastOpen, toastType },
  } = useSourcedCarrierRateFormSubmitter(onClose, shipperRateId, sourcedCarrierRate)

  const stepEditConfig = [
    {
      title: sourcedCarrierRate ? 'Edit Rate' : 'Add Rate',
      primaryActionConfig: {
        onClick: submitHandler,
        buttonText: 'Save',
        disabled: loading || !isFormValid,
      },
      secondaryActionConfig: {
        onClick: handleModalClose,
        buttonText: 'Cancel',
        disabled: loading,
      },
    },
  ]

  const steps = [
    <EditSourcedCarrierRateModalForm
      key='step-1'
      defaultCarrier={sourcedCarrierRate?.carrierApplication}
      hasExistingLaneAgreement={Boolean(sourcedCarrierRate?.latestLaneAgreement)}
    />,
  ]

  return (
    <FormProvider {...formMethods}>
      <FullPageOverlay
        open={open}
        onClose={handleModalClose}
        stepConfig={stepEditConfig}
        onPressBackButton={handleModalClose}
        currentStep={0}
        errors={submissionErrors}>
        {steps}
      </FullPageOverlay>

      <Toast variation={toastType} open={toastOpen} onClose={closeToast} message={toastMessage} />
    </FormProvider>
  )
}
